import { icons } from '@shared/static/icons';
import { getCryptoName } from '@utils/balance-helpers';

export default function RenderItemChannel({ item }) {
  return (
    <div className="select-bank-item">
      {icons[getCryptoName(item?.currency)]}
      <div>
        <p>{item?.label}</p>
        <p className="secondary-text">{item?.currency}</p>
      </div>
    </div>
  );
}
